type Locale = 'en' | 'es';
interface Vars {
  days: string;
}
type Phrase = (l: Locale, v: Vars) => string;

// eslint-disable-next-line camelcase
export const i18n_try_this_class_today_with_free_x_day_trial: Phrase = (locale, { days }) => {
  const en =  `Try this class today with a free ${days}-day trial. Enter your email to get started.`
  const phrases: { [key: string]: undefined | string } = {
    en,
    // TODO add spanish translation
    es: `Prueba esta clase hoy mismo con una prueba gratuita de ${days} días. Introduce tu email para comenzar.`,
  };
  return phrases[locale] || en
};
